import React, { useState } from 'react';
import { useTranslation } from "../../state/LanguageProvider";
import { Link, Text, MessageBar } from '@fluentui/react';
import styles from './Disclaimer.module.css';

interface DisclaimerProps {
  text: string;
  maxChars?: number;
}

const Disclaimer: React.FC<DisclaimerProps> = ({ text, maxChars = 50 }) => {
  const [expanded, setExpanded] = useState(false);
  const { getTranslation } = useTranslation();
  const isLongText = text.length > maxChars;
  const displayText = expanded || !isLongText ? text : text.slice(0, maxChars) + '...';

  return (
    <MessageBar>
      <div
        className={styles.disclaimer}
        dangerouslySetInnerHTML={{ __html: displayText }}
      ></div>
      {isLongText && (
        <div style={{ marginTop: 4 }}>
          <Link onClick={() => setExpanded(!expanded)} className={styles.disclaimerToggle}>
            {expanded ? getTranslation('show_less') : getTranslation('show_more') }
          </Link>
        </div>
      )}
    </MessageBar>
  );
};

export default Disclaimer;
